import { useState } from "react";
import { G, D3, D4, BR, T2, TX } from "../theme";
import { uploadFotoPerfil, atualizarPerfil, supabase } from "../supabase";

export default function Config(props) {
  var u = props.user;
  var inp = {width:"100%",background:D4,border:"1px solid "+BR,borderRadius:8,padding:"11px 14px",color:TX,fontSize:13,boxSizing:"border-box",outline:"none"};
  var [aba, setAba] = useState("perfil");
  var [nome, setNome] = useState(u ? u.nome : "");
  var [email, setEmail] = useState(u ? u.email : "");
  var [tel, setTel] = useState(u && u.telefone ? u.telefone : "");
  var [wpp, setWpp] = useState(u && u.whatsapp ? u.whatsapp : "");
  var [esp, setEsp] = useState(u && u.especialidade ? u.especialidade : "");
  var [cref, setCref] = useState(u && u.cref ? u.cref : "");
  var [bio, setBio] = useState(u && u.bio ? u.bio : "");
  var [sa, setSa] = useState(""), [sn, setSn] = useState(""), [sc, setSc] = useState(""), [serr, setSerr] = useState("");
  var av = nome.split(" ").map(function(p){ return p[0]; }).join("").slice(0,2).toUpperCase() || "??";

  function tabSt(t) {
    return {padding:"9px 18px",borderRadius:8,border:"none",cursor:"pointer",fontSize:13,fontWeight:500,background:aba===t?G+"22":"none",color:aba===t?G:T2};
  }

  async function salvarSenha() {
    setSerr("");
    if (sn.length < 6) { setSerr("Mínimo 6 caracteres."); return; }
    if (sn !== sc) { setSerr("Senhas não coincidem."); return; }
    var { error } = await supabase.auth.updateUser({ password: sn });
    if (error) { setSerr("Erro: " + error.message); return; }
    setSa(""); setSn(""); setSc("");
    props.onSalvar({ _msg: "Senha alterada com sucesso!" });
  }

  return (
    <div style={{flex:1,overflowY:"auto",background:"#0F0F0F",padding:"2rem"}}>
      <div style={{maxWidth:640,margin:"0 auto"}}>
        {props.msg && <div style={{fontSize:13,color:"#4CAF50",fontWeight:500,marginBottom:16,background:"#4CAF5011",border:"1px solid #4CAF5033",borderRadius:8,padding:"10px 14px"}}>{props.msg}</div>}
        <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:24,background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem"}}>
          <div style={{width:64,height:64,borderRadius:"50%",background:G+"33",border:"2px solid "+G,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:700,color:G,flexShrink:0,overflow:"hidden"}}>
            {u && u.foto_url ? <img src={u.foto_url} alt="avatar" style={{width:"100%",height:"100%",objectFit:"cover"}}/> : av}
          </div>
          <div>
            <div style={{fontWeight:600,fontSize:16,color:"#fff"}}>{nome||"Sem nome"}</div>
            <div style={{fontSize:12,color:T2,marginTop:2}}>{esp||"Profissional de saúde"}</div>
            <div style={{fontSize:11,color:G,marginTop:4}}>{cref||"Registro não informado"}</div>
          </div>
        </div>
        <div style={{display:"flex",gap:4,marginBottom:20,background:D3,border:"1px solid "+BR,borderRadius:10,padding:4}}>
          {[{id:"perfil",label:"Perfil"},{id:"contato",label:"Contato"},{id:"senha",label:"Senha"}].map(function(t){
            return <button key={t.id} onClick={function(){ setAba(t.id); }} style={tabSt(t.id)}>{t.label}</button>;
          })}
        </div>

        {aba==="perfil" && (
          <div style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1.5rem"}}>
            <div style={{fontSize:13,fontWeight:600,color:G,marginBottom:16}}>Informações pessoais</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
              <div><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Nome *</label><input value={nome} onChange={function(e){ setNome(e.target.value); }} style={inp}/></div>
              <div><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Especialidade</label><input value={esp} onChange={function(e){ setEsp(e.target.value); }} style={inp}/></div>
            </div>
            <div style={{marginBottom:14}}><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>CREF / CRN</label><input value={cref} onChange={function(e){ setCref(e.target.value); }} style={{...inp,maxWidth:"55%"}}/></div>
            <div style={{marginBottom:20}}><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Bio</label><textarea value={bio} onChange={function(e){ setBio(e.target.value); }} rows={3} style={{...inp,resize:"vertical",lineHeight:1.6}}/></div>
            <div style={{marginBottom:14}}>
              <label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Foto de perfil</label>
              <input type="file" accept="image/*" onChange={async function(e){
                var file = e.target.files[0];
                if (!file) return;
                var label = e.target.parentNode.querySelector('span');
                if (label) label.textContent = "A carregar...";
                var url = await uploadFotoPerfil(u.id, file);
                if (url) {
                  await atualizarPerfil(u.id, { foto_url: url });
                  props.onSalvar({ foto_url: url });
                  if (label) label.textContent = "✓ Foto atualizada!";
                  setTimeout(function(){ if (label) label.textContent = ""; }, 3000);
                } else {
                  if (label) label.textContent = "Erro ao carregar foto.";
                }
              }} style={{color:T2,fontSize:12}}/>
              <span style={{fontSize:11,color:"#4CAF50",marginLeft:8}}></span>
            </div>
            <button onClick={async function(){
              await atualizarPerfil(u.id, {nome:nome,email:email,especialidade:esp,cref:cref,bio:bio,avatar:av});
              props.onSalvar({nome:nome,email:email,especialidade:esp,cref:cref,bio:bio,avatar:av});
            }} style={{background:G,color:"#000",border:"none",borderRadius:9,padding:"11px 24px",fontWeight:600,fontSize:14,cursor:"pointer"}}>Salvar perfil</button>
          </div>
        )}

        {aba==="contato" && (
          <div style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1.5rem"}}>
            <div style={{fontSize:13,fontWeight:600,color:G,marginBottom:16}}>Dados de contato</div>
            <div style={{marginBottom:14}}><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>E-mail</label><input value={email} onChange={function(e){ setEmail(e.target.value); }} style={inp}/></div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:20}}>
              <div><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Telefone</label><input value={tel} onChange={function(e){ setTel(e.target.value); }} placeholder="(11) 99999-9999" style={inp}/></div>
              <div><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>WhatsApp</label><input value={wpp} onChange={function(e){ setWpp(e.target.value); }} placeholder="(11) 99999-9999" style={inp}/></div>
            </div>
            <button onClick={async function(){
              await atualizarPerfil(u.id, {email:email,telefone:tel,whatsapp:wpp});
              props.onSalvar({email:email,telefone:tel,whatsapp:wpp});
            }} style={{background:G,color:"#000",border:"none",borderRadius:9,padding:"11px 24px",fontWeight:600,fontSize:14,cursor:"pointer"}}>Salvar contato</button>
          </div>
        )}

        {aba==="senha" && (
          <div style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1.5rem"}}>
            <div style={{fontSize:13,fontWeight:600,color:G,marginBottom:16}}>Alterar senha</div>
            <div style={{marginBottom:14}}><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Senha atual</label><input type="password" value={sa} onChange={function(e){ setSa(e.target.value); }} style={inp}/></div>
            <div style={{marginBottom:14}}><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Nova senha</label><input type="password" value={sn} onChange={function(e){ setSn(e.target.value); }} style={inp}/></div>
            <div style={{marginBottom:18}}><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Confirmar</label><input type="password" value={sc} onChange={function(e){ setSc(e.target.value); }} style={inp}/></div>
            {serr && <div style={{fontSize:12,color:"#E53935",marginBottom:12}}>{serr}</div>}
            <button onClick={salvarSenha} style={{background:G,color:"#000",border:"none",borderRadius:9,padding:"11px 24px",fontWeight:600,fontSize:14,cursor:"pointer"}}>Alterar senha</button>
          </div>
        )}
      </div>
    </div>
  );
}
